import { type Enum } from '../../utils/enums'

export const VendorTypes = {
  OTHER: 1,
  PUNCHOUT: 2,
  PREFERRED: 3,
  REGULAR: 4,
  EMPLOYEE: 5,
  CREDIT_CARD_PROVIDER: 6,
  CHECKOUT: 7,
} as const

export type VendorType = Enum<typeof VendorTypes>
